export default {
  props: {
    company: {
      type: String,
      default: '',
    },
    installation: {
      type: String,
      default: '',
    },
    regional: {
      type: String,
      default: '',
    },
    asset: {
      type: String,
      default: '',
    },
  },
  computed: {
    items() {
      return [
        {
          title: this.$t('header.company'),
          data: this.getData(this.company),
        },
        {
          title: this.$t('header.regional'),
          data: this.getData(this.regional),
        },
        {
          title: this.$t('header.installation'),
          data: this.getData(this.installation),
        },
        {
          title: this.$t('header.asset'),
          data: this.getData(this.asset),
        },
      ];
    },
  },
  methods: {
    getData(value) {
      if (!value) {
        return [];
      }
      return [{ name: value }];
    },
  },
};
